export default "__VITE_PUBLIC_ASSET__d564ce00__"